import React from "react";
import "./index.css";
import Flow from "./components/Flow";
import SidePanel from "./components/SidePanel";
import UnitInfo from "./components/UnitInfo";
import { useState, useEffect } from "react";
import Header from "./components/Header";
import { HStack, VStack, Text } from "@chakra-ui/react";

function App() {
  const [selectedUnit, setSelectedUnit] = useState("");
  const [coursemapUnits, setCoursemapUnits] = useState(Array(24).fill(""));

  const buttonsToGenerate = [
    { text: "Home", onClick: () => console.log("clicked"), colour: "beige" },
    { text: "About", onClick: () => console.log("clicked"), colour: "beige" },
    { text: "Help", onClick: () => console.log("clicked"), colour: "#FAA8FF" },
  ];

  const generateButton = (paramObject: any) => {
    const { text, onClick, colour } = paramObject;
    return (
      <div style={{ padding: 50, display: "inline-block" }}>
        <button
          className="round_button"
          style={{
            backgroundColor: colour,
            borderRadius: 12,
            padding: 20,
          }}
          onClick={onClick}
        >
          {text}
        </button>
      </div>
    );
  };

  const buttons = buttonsToGenerate.map((buttonParams) => generateButton(buttonParams));

  return (
    <div className="grid grid-cols-5">
      <div className="col-span-5">
        <Header />
      </div>
      <div className="col-span-3 h-200" style={{ minHeight: 1000 }}>
        <Flow setSelectedUnit={setSelectedUnit} coursemapUnits={coursemapUnits} />
      </div>
      <div className="bg-gray-100 drop-shadow-md border-l-2 border-gray-200 overflow-y-auto col-span-2 h-100">

        <HStack>
          <VStack paddingLeft={5}>
            <Text fontWeight={"bold"} fontSize="3xl">
              Instructions
            </Text>
            <Text fontSize={"md"}>
              1. <b>Click</b> on the nodes to <b>copy</b> the unit code into your <b>coursemap.</b><br/>
              2. <b>Click</b> on the node to <b>read more</b> about the unit's information on the right.<br/>
              3. <b>Arrows</b> represent <b>prerequisites</b>, <b>same-coloured dotted lines</b> indicate that taking any of those units would satisfy the <b>prerequisites</b> for the given unit.<br />
              4. <b>Double click</b> on the <b>coursemap slots</b> to <b>paste</b> your unit code in.
            </Text>
          </VStack>
          <img
            style={{ marginTop: "10px" }}
            src="https://cdn.discordapp.com/attachments/907207517468229692/1010828635210522695/Legend.png"
          />
        </HStack>
        <UnitInfo unitInfo={selectedUnit} />
        <SidePanel coursemapUnits={coursemapUnits} setCoursemapUnits={setCoursemapUnits} />
      </div>
    </div>
  );
}
export default App;
